import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import emailIcon from "../../Img/footer/emailIcon.png";
import locationIcon from "../../Img/footer/locationIcon.png";
import linkedin from "../../Img/footer/linkedin.png";
import instagram from "../../Img/footer/instagram.png";
import youtube from "../../Img/footer/youtube.png";
import googleStore from "../../Img/footer/googleStore.png";
import appleStore from "../../Img/footer/appStore.png";
const Footer = ({ isSidebar, select, setIsSelect }) => {
  const onClick = (e) => {
    setIsSelect(e.target.innerText);
  };
  return (
    <div className={styles.container}>
      <div className={!isSidebar ? styles.menuAndLink : styles.opacityZero}>
        <div className={styles.menuContainer}>
          <div className={styles.contentsContainer}>
            <ul className={styles.menuList}>
              <Link to="/culture" onClick={onClick}>
                문화와 복지
              </Link>
              <Link to="/position" onClick={onClick}>
                채용 중인 직무
              </Link>
              {/* <Link to="/faq">자주 묻는 질문</Link> */}
            </ul>
          </div>
          <div className={styles.companyInfo}>
            <div className={styles.email}>
              <img src={emailIcon} alt="" /> <span>recruit@mondayoff.me</span>
            </div>
            <div className={styles.location}>
              <img src={locationIcon} alt="" />
              <span>
                14F, 465, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea
              </span>
            </div>
          </div>
        </div>
        <div className={styles.linkContainer}>
          <div className={styles.snsIconContainer}>
            <a
              href="https://www.linkedin.com/company/mondayoff-inc/mycompany/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="" />
            </a>
            <a
              a
              href="https://www.instagram.com/mondayoff_official/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={instagram} alt="" />
            </a>
            <a
              a
              href="https://www.youtube.com/channel/UCgYNSY4mEvtTjGUG7L56k6w"
              target="_blank"
              rel="noreferrer"
            >
              <img src={youtube} alt="" />
            </a>
          </div>
          <div className={styles.storeContainer}>
            <a
              href="https://apps.apple.com/us/developer/mondayoff/id1448226898"
              target="_blank"
              rel="noreferrer"
            >
              <img src={appleStore} alt="" />
            </a>
            <a
              href="https://play.google.com/store/apps/developer?id=MondayOFF&hl=ko&gl=US"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googleStore} alt="" />
            </a>
          </div>
        </div>
      </div>

      <div className={!isSidebar ? styles.termContainer : styles.opacityZero}>
        <span>©2022 MondayOFF</span>
        <a
          href="https://mondayoff.me/privacyPolicy.html"
          target="_blank"
          rel="noreferrer"
        >
          Privacy
        </a>
      </div>
    </div>
  );
};

export default Footer;
